
var React = require('react'),
    ReactDOM = require('react-dom');

var CodyPlayer = require('./src/cody.jsx');

if (window && $) {
  $.fn.player = function(options) {
    if (options == "status") {
      var player = ReactDOM.render(<CodyPlayer />, $(this)[0]);
      return player.status();
    } else {
      ReactDOM.render(<CodyPlayer {...options} />, $(this)[0]);
    }
  };
}

module.exports = {
  Player: CodyPlayer
};



// WEBPACK FOOTER //
// ./cody.js